import { useMemo } from 'react'
import { match } from 'ts-pattern'

import { Maybe } from 'aem-libs-ts/src/types/utility'
import { isDefined } from 'aem-libs-ts/src/utils/common/isDefined'

import { isDefaultItem } from '../selectHelper'
import { FormatValue, SelectValueType } from '../types'
import { useFindOptionByValue } from './useFindOptionByValue'

export const useInputLabel = <TOption, TValue extends SelectValueType>(
  items: TOption[],
  value: TValue,
  isOpen: boolean,
  searchEnabled: Maybe<boolean>,
  searchValue: string,
  formatValue: FormatValue<TOption, TValue>
) => {
  const tryFindOptionByValue = useFindOptionByValue(items, formatValue)
  const getOptionLabelByValue = (value: TValue) => {
    const option = tryFindOptionByValue(value)
    return isDefaultItem(option) ? option.label : ''
  }

  return useMemo(() => {
    return match({ isOpen, searchEnabled, searchValue, value })
      .when(
        (state) => state.searchEnabled && state.isOpen && state.searchValue,
        (state) => state.searchValue
      )
      .when(
        (state) => !state.isOpen && isDefined(value),
        (state) => {
          return getOptionLabelByValue(state.value)
        }
      )
      .when(
        (state) => state.isOpen && isDefined(value) && !searchEnabled,
        (state) => {
          return getOptionLabelByValue(state.value)
        }
      )
      .otherwise(() => '')
  }, [items, isOpen, value, searchEnabled, searchValue])
}
